import { DEPARTMENTS, DEPARTMENT_LABEL } from './departments.js';
import { SCREENS } from './roles.js';
/** Seřazené obrazovky oddělení (návrh kap. 5.1); „Můj přehled“ je vždy první a v seznamech není. */
export const DEPARTMENT_NAV = {
    customer_care: ['care', 'customers', 'reviews', 'trips', 'exceptions', 'races'],
    mailing: [
        'communication',
        'compose',
        'deliverability',
        'web_behavior',
        'transactional',
        'jobs',
        'exceptions',
        'data_quality',
        'settings',
        'simulator',
    ],
    obchod: [
        'races',
        'trips',
        'customers',
        'transactional',
        'exceptions',
        'revenue',
        'data_quality',
        'web_behavior',
    ],
    marketing: [
        'revenue',
        'communication',
        'compose',
        'deliverability',
        'web_behavior',
        'races',
        'reviews',
        'data_quality',
    ],
    admin: ['settings', 'simulator', 'jobs', 'data_quality'],
};
/**
 * Pořadí sekcí: oddělení uživatele podle priority. Administrátor dostane sekce všech oddělení
 * a systémová sekce „Administrátor“ je poslední.
 */
function sectionOrder(departments) {
    if (departments.includes('admin')) {
        return [...DEPARTMENTS.filter((d) => d !== 'admin'), 'admin'];
    }
    return DEPARTMENTS.filter((d) => departments.includes(d));
}
/**
 * Menu: sekce po odděleních, obrazovka jen jednou (u první sekce, která ji obsahuje) a jen
 * pokud ji uživatel smí číst; zbytek čitelných obrazovek jde do sekce „Další“.
 */
export function navFor(departments, canRead) {
    const shown = new Set(['overview']);
    const sections = [];
    // Systémové obrazovky patří sekci „Administrátor“ (i když je ukazujeme poslední), proto ji
    // „obsadí“ jako první; jinak by je převzala sekce Mailing a administrátorská by zůstala prázdná.
    const claim = departments.includes('admin') ? ['admin'] : [];
    const byKey = new Map();
    for (const d of [...claim, ...sectionOrder(departments)]) {
        if (byKey.has(d))
            continue;
        const screens = DEPARTMENT_NAV[d].filter((s) => canRead(s) && !shown.has(s));
        screens.forEach((s) => shown.add(s));
        if (screens.length > 0)
            byKey.set(d, { key: d, title: DEPARTMENT_LABEL[d], screens });
    }
    for (const d of sectionOrder(departments)) {
        const section = byKey.get(d);
        if (section)
            sections.push(section);
    }
    const rest = SCREENS.filter((s) => canRead(s) && !shown.has(s));
    if (rest.length > 0)
        sections.push({ key: 'other', title: 'Další', screens: rest });
    return sections;
}
//# sourceMappingURL=nav.js.map